<template>
  <RCard class="workflow">
    <Grid gaf="column" justify-content="space-between" align-items="center" class="header">
      <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
        <div class="text-subtitle-1 text-secondary-2">Workflow <HelpPageBtn :page="__guide.workflowIntro" /></div>

        <RDropdown
          :value="subscriptionPeriods.length ? periodId : 'Loading...'"
          :options="subscriptionPeriods"
          :loading="!periodId"
          :disable="!periodId"
          no-hint
          no-label
          emit-value
          map-options
          style="min-width: 185px"
          @input="periodId = $event"
        />
      </Grid>

      <EditManagedBy :sub-id="id" />
    </Grid>

    <div v-if="periodId" class="body q-mt-lg">
      <TasksWrapper :key="periodId" from="subscription" :period-id="periodId" />
      <MilestoneTabs ref="milestoneTabs" :key="reRenderMilestoneTabs" class="q-mt-lg" />
    </div>
  </RCard>
</template>

<script>
import { periodRenderer } from '@/lib/generic.utils'
// Components
import MilestoneTabs from '@/components/milestones/MilestoneTabs'
import EditManagedBy from './components/EditManagedBy'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import TasksWrapper from '@/reusable/workflow/TasksWrapper'

export default {
  name: 'WorkflowTab',

  components: {
    MilestoneTabs,
    EditManagedBy,
    HelpPageBtn,
    TasksWrapper
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    reRenderMilestoneTabs: 0
  }),

  computed: {
    subscriptionPeriods() {
      return this.$store.getters['subscription-show/subscriptionPeriods'].map(period => ({
        ...period,
        label: periodRenderer(period),
        value: period.id
      }))
    },

    periodId: {
      get() {
        return this.$store.getters['subscription-show/periodId']
      },

      set(newVal) {
        this.$store.commit('subscription-show/setPeriodId', newVal)
      }
    }
  },

  watch: {
    periodId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || newVal === oldVal) return
        this.periodId = newVal
      }
    }
  },

  created() {
    this.$root.$on('refresh-all-tasks', periodId => {
      if (periodId === this.periodId) this.periodId = periodId
    })
    this.$root.$on('refresh-milestone-tabs', periodId => {
      if (periodId === this.periodId) this.reRenderMilestoneTabs++
    })
  },

  beforeDestroy() {
    this.$root.$off('refresh-all-tasks')
    this.$root.$off('refresh-milestone-tabs')
  }
}
</script>
